import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { isKeyTab, isShortcutPaste } from "../../../lib/events/keyboard/identifiers";
import { MouseDrag } from "../../../lib/events/MouseDrag";
import { isEdge, isIE11, isMobile } from "../../../lib/client";
import { removeAllSelections, selectNodeContents } from "../../../components/DateInput/helpers/SelectionHelpers";
import { styles as jsInputStyles } from "../../../components/Input/Input.styles";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CommonWrapper } from "../../CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { findRenderContainer } from "../../../lib/listenFocusOutside";
import { styles } from "../InputLikeText.styles";
import { HiddenInput } from "../HiddenInput";
export var InputLikeText = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InputLikeText, _React$Component);

  function InputLikeText() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      blinking: false,
      focused: false
    };
    _this.theme = void 0;
    _this.node = null;
    _this.hiddenInput = null;
    _this.lastSelectedInnerNode = null;
    _this.frozen = false;
    _this.frozenBlur = false;
    _this.dragging = false;
    _this.focusTimeout = void 0;
    _this.blinkTimeout = void 0;

    _this.selectInnerNode = function (node, start, end) {
      if (start === void 0) {
        start = 0;
      }

      if (end === void 0) {
        end = 1;
      }

      if (_this.dragging || !node) {
        return;
      }

      if (isIE11 && findRenderContainer(node, document.body)) {
        // Code below causes Popup to close after triggering the focus event on the body in IE11
        return;
      }

      _this.frozen = true;
      _this.frozenBlur = true;
      _this.lastSelectedInnerNode = [node, start, end];
      setTimeout(function () {
        return selectNodeContents(node, start, end);
      }, 0);

      if (_this.focusTimeout) {
        clearInterval(_this.focusTimeout);
      }

      _this.focusTimeout = window.setTimeout(function () {
        return (isIE11 || isEdge) && _this.node && _this.node.focus();
      }, 0);
    };

    _this.renderMain = function (props) {
      var _cx, _cx2, _cx3;

      var innerRef = props.innerRef,
          tabIndex = props.tabIndex,
          placeholder = props.placeholder,
          align = props.align,
          borderless = props.borderless,
          width = props.width,
          size = props.size,
          error = props.error,
          warning = props.warning,
          onValueChange = props.onValueChange,
          disabled = props.disabled,
          prefix = props.prefix,
          suffix = props.suffix,
          leftIcon = props.leftIcon,
          rightIcon = props.rightIcon,
          value = props.value,
          onMouseDragStart = props.onMouseDragStart,
          onMouseDragEnd = props.onMouseDragEnd,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef", "tabIndex", "placeholder", "align", "borderless", "width", "size", "error", "warning", "onValueChange", "disabled", "prefix", "suffix", "leftIcon", "rightIcon", "value", "onMouseDragStart", "onMouseDragEnd"]);

      var _this$state = _this.state,
          focused = _this$state.focused,
          blinking = _this$state.blinking;

      var leftSide = _this.renderLeftSide();

      var rightSide = _this.renderRightSide();

      var className = cx(styles.root(), jsInputStyles.root(_this.theme), _this.getSizeClassName(), (_cx = {}, _cx[jsInputStyles.focus(_this.theme)] = focused, _cx[jsInputStyles.blink(_this.theme)] = blinking, _cx[jsInputStyles.warning(_this.theme)] = !!warning, _cx[jsInputStyles.error(_this.theme)] = !!error, _cx[jsInputStyles.focusFallback(_this.theme)] = focused && (isIE11 || isEdge), _cx[jsInputStyles.warningFallback(_this.theme)] = !!warning && (isIE11 || isEdge), _cx[jsInputStyles.errorFallback(_this.theme)] = !!error && (isIE11 || isEdge), _cx[jsInputStyles.disabled(_this.theme)] = !!disabled, _cx[jsInputStyles.borderless()] = !!borderless, _cx[jsInputStyles.hideBlinkingCursor()] = isMobile, _cx));
      var wrapperClass = cx(jsInputStyles.wrapper(), (_cx2 = {}, _cx2[styles.userSelectContain()] = focused, _cx2));
      return /*#__PURE__*/React.createElement("span", _extends({}, rest, {
        className: className,
        style: {
          width: width,
          textAlign: align
        },
        tabIndex: disabled ? undefined : 0,
        onFocus: _this.handleFocus,
        onBlur: _this.handleBlur,
        ref: _this.innerRef,
        onKeyDown: _this.handleKeyDown,
        onMouseDown: _this.handleMouseDown
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        value: value
      }), leftSide, /*#__PURE__*/React.createElement("span", {
        className: wrapperClass
      }, /*#__PURE__*/React.createElement("span", {
        "data-tid": "InputLikeText__input",
        className: cx(styles.input(), jsInputStyles.input(_this.theme), (_cx3 = {}, _cx3[jsInputStyles.inputFocus(_this.theme)] = focused, _cx3[jsInputStyles.inputDisabled(_this.theme)] = disabled, _cx3))
      }, _this.props.children), _this.renderPlaceholder()), rightSide, isIE11 && focused && /*#__PURE__*/React.createElement(HiddenInput, {
        nodeRef: _this.hiddenInputRef
      }));
    };

    _this.renderLeftIcon = function () {
      return _this.renderIcon(_this.props.leftIcon, _this.getIconClassname());
    };

    _this.renderRightIcon = function () {
      return _this.renderIcon(_this.props.rightIcon, _this.getIconClassname(true));
    };

    _this.renderIcon = function (icon, className) {
      var _cx4;

      if (!icon) {
        return null;
      }

      var disabled = _this.props.disabled;
      var iconNode = icon instanceof Function ? icon() : icon;
      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.icon(), className, jsInputStyles.useDefaultColor(_this.theme), (_cx4 = {}, _cx4[jsInputStyles.iconDisabled()] = disabled, _cx4))
      }, iconNode);
    };

    _this.renderPrefix = function () {
      var _cx5;

      var _this$props = _this.props,
          prefix = _this$props.prefix,
          disabled = _this$props.disabled;

      if (!prefix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.prefix(_this.theme), (_cx5 = {}, _cx5[jsInputStyles.prefixDisabled(_this.theme)] = disabled, _cx5))
      }, prefix);
    };

    _this.renderSuffix = function () {
      var _cx6;

      var _this$props2 = _this.props,
          suffix = _this$props2.suffix,
          disabled = _this$props2.disabled;

      if (!suffix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.suffix(_this.theme), (_cx6 = {}, _cx6[jsInputStyles.suffixDisabled(_this.theme)] = disabled, _cx6))
      }, suffix);
    };

    _this.renderLeftSide = function () {
      var leftIcon = _this.renderLeftIcon();

      var prefix = _this.renderPrefix();

      if (!leftIcon && !prefix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: jsInputStyles.sideContainer()
      }, leftIcon, prefix);
    };

    _this.renderRightSide = function () {
      var rightIcon = _this.renderRightIcon();

      var suffix = _this.renderSuffix();

      if (!rightIcon && !suffix) {
        return null;
      }

      return /*#__PURE__*/React.createElement("span", {
        className: cx(jsInputStyles.sideContainer(), jsInputStyles.rightContainer())
      }, rightIcon, suffix);
    };

    _this.renderPlaceholder = function () {
      var _this$props3 = _this.props,
          children = _this$props3.children,
          placeholder = _this$props3.placeholder,
          disabled = _this$props3.disabled;
      var focused = _this.state.focused;

      if (!children && placeholder) {
        var _cx7;

        return /*#__PURE__*/React.createElement("span", {
          className: cx(jsInputStyles.placeholder(_this.theme), (_cx7 = {}, _cx7[jsInputStyles.placeholderDisabled(_this.theme)] = disabled, _cx7[jsInputStyles.placeholderFocus(_this.theme)] = focused, _cx7))
        }, placeholder);
      }

      return null;
    };

    _this.handleDocumentMouseDown = function (e) {
      if (_this.state.focused && _this.node && e.target instanceof Node && !_this.node.contains(e.target)) {
        _this.defrost();
      }
    };

    _this.handleDocumentKeyDown = function (e) {
      if (_this.state.focused && isKeyTab(e)) {
        _this.defrost();
      }
    };

    _this.handleMouseDown = function (e) {
      _this.frozen = true;
    };

    _this.handleKeyDown = function (e) {
      if (_this.props.disabled) {
        return;
      }

      if (isIE11 && isShortcutPaste(e) && _this.hiddenInput) {
        _this.frozen = true;
        setTimeout(function () {
          if (_this.lastSelectedInnerNode) {
            var _this2;

            (_this2 = _this).selectInnerNode.apply(_this2, _this.lastSelectedInnerNode);
          }

          if (_this.node) {
            _this.node.focus();
          }
        }, 0);

        _this.hiddenInput.focus();
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleMouseDragStart = function (e) {
      _this.dragging = true;
      document.documentElement.classList.add(styles.userSelectNone());

      if (_this.props.onMouseDragStart) {
        _this.props.onMouseDragStart(e);
      }
    };

    _this.handleMouseDragEnd = function (e) {
      // Дожидаемся onMouseUp
      setTimeout(function () {
        _this.dragging = false;

        if (_this.props.onMouseDragEnd) {
          _this.props.onMouseDragEnd(e);
        }
      }, 0);
      document.documentElement.classList.remove(styles.userSelectNone());
    };

    _this.handleFocus = function (e) {
      if (isMobile) {
        e.target.setAttribute('contenteditable', 'true');
      }

      if (_this.props.disabled) {
        if (isIE11) {
          selectNodeContents(document.body, 0, 0);
        }

        return;
      }

      if ((isIE11 || isEdge) && _this.frozen) {
        _this.frozen = false;

        if (_this.state.focused) {
          return;
        }
      }

      _this.setState({
        focused: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(e);
      }
    };

    _this.handleBlur = function (e) {
      if (isMobile) {
        e.target.removeAttribute('contenteditable');
      }

      if (_this.props.disabled) {
        e.stopPropagation();
        return;
      }

      if ((isIE11 || isEdge) && _this.frozenBlur) {
        _this.frozenBlur = false;
        return;
      }

      if ((isIE11 || isEdge) && _this.frozen) {
        return;
      }

      removeAllSelections();

      _this.setState({
        focused: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(e);
      }
    };

    _this.hiddenInputRef = function (el) {
      _this.hiddenInput = el;
    };

    _this.innerRef = function (el) {
      if (_this.props.innerRef) {
        _this.props.innerRef(el);
      }

      _this.node = el;
    };

    _this.defrost = function () {
      _this.frozen = false;
      _this.frozenBlur = false;
    };

    _this.getSizeClassName = function () {
      var _cx8, _cx9, _cx10;

      switch (_this.props.size) {
        case 'large':
          return cx((_cx8 = {}, _cx8[jsInputStyles.sizeLarge(_this.theme)] = true, _cx8[jsInputStyles.sizeLargeFallback(_this.theme)] = isIE11 || isEdge, _cx8));

        case 'medium':
          return cx((_cx9 = {}, _cx9[jsInputStyles.sizeMedium(_this.theme)] = true, _cx9[jsInputStyles.sizeMediumFallback(_this.theme)] = isIE11 || isEdge, _cx9));

        case 'small':
        default:
          return cx((_cx10 = {}, _cx10[jsInputStyles.sizeSmall(_this.theme)] = true, _cx10[jsInputStyles.sizeSmallFallback(_this.theme)] = isIE11 || isEdge, _cx10));
      }
    };

    return _this;
  }

  var _proto = InputLikeText.prototype;
  /**
  * @public
  */

  _proto.focus = function focus() {
    if (this.node) {
      this.node.focus();
    }
  }
  /**
  * @public
  */
  ;

  _proto.blur = function blur() {
    if (this.node) {
      this.node.blur();
    }
  }
  /**
  * @public
  */
  ;

  _proto.blink = function blink() {
    var _this3 = this;

    if (this.props.disabled) {
      return;
    }

    this.setState({
      blinking: true
    }, function () {
      _this3.blinkTimeout = window.setTimeout(function () {
        return _this3.setState({
          blinking: false
        });
      }, 150);
    });
  };

  _proto.getNode = function getNode() {
    return this.node;
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.node) {
      MouseDrag.listen(this.node).onMouseDragStart(this.handleMouseDragStart).onMouseDragEnd(this.handleMouseDragEnd);
    }

    document.addEventListener('mousedown', this.handleDocumentMouseDown);
    document.addEventListener('keydown', this.handleDocumentKeyDown);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.blinkTimeout) {
      clearTimeout(this.blinkTimeout);
    }

    MouseDrag.stop(this.node);
    document.removeEventListener('mousedown', this.handleDocumentMouseDown);
    document.removeEventListener('keydown', this.handleDocumentKeyDown);
  };

  _proto.render = function render() {
    var _this4 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this4.theme = theme;
      return /*#__PURE__*/React.createElement(CommonWrapper, _this4.props, _this4.renderMain);
    });
  };

  _proto.getIconClassname = function getIconClassname(right) {
    if (right === void 0) {
      right = false;
    }

    switch (this.props.size) {
      case 'large':
        return right ? jsInputStyles.rightIconLarge(this.theme) : jsInputStyles.leftIconLarge(this.theme);

      case 'medium':
        return right ? jsInputStyles.rightIconMedium(this.theme) : jsInputStyles.leftIconMedium(this.theme);

      case 'small':
      default:
        return right ? jsInputStyles.rightIconSmall(this.theme) : jsInputStyles.leftIconSmall(this.theme);
    }
  };

  return InputLikeText;
}(React.Component);
InputLikeText.__KONTUR_REACT_UI__ = 'InputLikeText';
InputLikeText.defaultProps = {
  size: 'small'
};